<h1 mat-dialog-title>{{ 'dialogs.confirm.title' | translate }}</h1>

<mat-dialog-content>
  <!-- The text of the legacy dialog: an i18n string of ours with <br>, which the sanitizer keeps -->
  <div [innerHTML]="messageKey | translate" class="mb-3"></div>

  <div class="text-center my-3" *ngIf="state === 'loading'">
    <mat-spinner diameter="30" class="d-inline-block"></mat-spinner>
  </div>

  <div class="alert alert-warning" *ngIf="state === 'failed'">
    {{ 'properties.documentsV3.mappingDocsDialog.loadError' | translate }}
  </div>

  <div class="row mb-1" *ngIf="showNoDocs">
    <div class="text-wrapper ml-3">
      {{ 'properties.structures.textConfimFormRemakeNoDocs' | translate }}
    </div>
  </div> <!-- ./row -->

  <div class="mb-1" *ngIf="state === 'loaded' && rows.length">
    <table class="table table-borderless">
      <thead>
        <th>{{ 'properties.documentsPage.docType' | translate }}</th>
        <th>{{ 'properties.documentsPage.descr' | translate }}</th>
        <th>{{ 'properties.documentsPage.date' | translate }}</th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td>
            <mat-checkbox *ngIf="isRemake" [(ngModel)]="row.selected" class="checkbox-insert">
              {{ row.title }}
            </mat-checkbox>
            <ng-container *ngIf="!isRemake">{{ row.title }}</ng-container>
          </td>
          <td>{{ row.content }}</td>
          <td>{{ row.docDate | date }}</td>
          <td>
            <a mat-button *ngIf="row.files.length" (click)="onDownload(row)"
              mat-raised-button mat-default color="primary">
              <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
              </mat-icon>
              {{ 'common.cta.download' | translate }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div> <!-- ./row -->

  <div class="alert alert-warning" *ngIf="tooManySelected">
    {{ 'properties.documentsV3.mappingDocsDialog.tooManySelected' | translate: { max: maxRemakeDocs } }}
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="mt-5">
  <div class="row w-100">
    <div class="col-6 text-left">
      <button type="button" mat-raised-button color="warn" (click)="onDenial()">
        {{ 'common.cta.undo' | translate }}
      </button>
    </div> <!-- /.col -->
    <div class="col-6 text-right">
      <button type="button" mat-raised-button color="primary" [disabled]="!canConfirm" (click)="onConfirmation()">
        {{ 'common.cta.confirm' | translate }}
      </button>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
